<app-drtv-menu></app-drtv-menu>

<section class="drtv-header">
  <div class="drtv-banner"></div>

  <div class="drtv-greeting">
    <img
      src="https://resources.childrensmiraclenetworkhospitals.org/cdn/images/drtv/MarieDRTVPortrait.jpg"
      class="drtv-greeting__portrait"
      alt="Marie Osmond"
    />

    <div class="drtv-greeting__shell">
      <div class="drtv-greeting__content">
        <h1 class="drtv-tagline">“Make <b>every moment</b> count.”</h1>
        <h2>
          <span class="name"
            ><span class="drtv-mobile-prefix">- </span>Marie Osmond</span
          ><span class="drtv-desktop-separator"> - </span><br class="drtv-mobile-break" />Co-Founder,
          Children’s Miracle Network
        </h2>
      </div>
    </div>

    <div class="give-btn-container">
      <app-cmn-button
        class="drtv-give-button"
        type="button"
        variant="secondary"
        size="large"
        title="Give Now"
        (buttonClick)="scrollToDonate($event)">
        Give Now
      </app-cmn-button>
    </div>
  </div>
</section>

<section class="hospital-search-section" id="hospitalSearch" #hospitalSearch>
  <div class="drtv-section-shell">
    <div class="hospital-search-intro">
      <h2 class="hospital-search-title">
        Your donation will go directly to
        <b>your nearest member hospital of Children's Miracle Network.</b>
      </h2>
    </div>

    <div class="hospital-search-copy">
      <p>
        Input your billing zip code to find the Children’s Miracle Network
        member hospital closest to you:
      </p>
    </div>

    <div class="hospital-search-widget">
      <app-hospital-search [showTitle]="false" [largeSearch]="true"></app-hospital-search>
    </div>
  </div>
</section>

<section class="drtv-donate-section" id="donateNow" #donateNow>
  <div class="drtv-section-shell">
    <div class="drtv-donate-content">
      <h2 class="donate-title">
        <b>Make a difference</b><br />in a child’s life near you
      </h2>

      <app-donate [drtv]="true" #donateComponent class="drtv-donation"></app-donate>

      <drtv-thankyou (onPageRefresh)="onDrtvThankyouPageRefresh($event)" [hidden]="!donationProcessed"></drtv-thankyou>
        
      <div class="drtv-guidestar-row">
        <a
          href="https://www.guidestar.org/profile/87-0387205"
          target="_blank"
          class="guidestar"
          style="outline: currentcolor none medium"
          ><img
            src="https://widgets.guidestar.org/gximage2?o=8291642&amp;l=v4"
        /></a>
      </div>
    </div>
  </div>
</section>

<app-drtv-stats></app-drtv-stats>

<app-drtv-grid></app-drtv-grid>

<app-drtv-lower-section></app-drtv-lower-section>

<app-drtv-footer></app-drtv-footer>
